// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__ckJlg","content":"Consent_content__w6y7H","footer":"Consent_footer__1rBQK"};